import { z } from "zod";

import { UserUpdateProfileDtoPronoun } from "@/hooks/api/generated";

export const downloadBrochureSchema = z
  .object({
    first_name: z.string().min(1, { message: "Required." }),
    last_name: z.string().min(1, { message: "Required." }),
    email: z
      .string()
      .min(1, { message: "Required." })
      .email({ message: "Invalid email address." }),
    phone_number: z
      .string()
      .optional()
      .refine((val) => val === undefined || /^\d{6,}$/.test(val), {
        message:
          "Phone number must be at least 6 digits and contain only digits.",
      }),
    location: z.string().min(1, { message: "Location is required." }),
    organization: z.string().min(1, { message: "Required." }),
    job_title: z.string().optional(),
    is_hiring: z.boolean({
      required_error: "Please select if you are hiring.",
    }),
    pronoun: z
      .nativeEnum(UserUpdateProfileDtoPronoun)
      .refine(
        (val) => Object.values(UserUpdateProfileDtoPronoun).includes(val),
        { message: "Required" }
      ),
    interested_in_becoming: z.string().min(1, {
      message: "I'm Interested in becoming is Required.",
    }),
    // Make these optional initially
    size_of_organization: z.string().optional(),
    number_of_vacancies: z.string().optional(),
    want_to_reach_out: z.string().optional(),
    privacyPolicy: z.boolean().refine((val) => val === true, {
      message: "Please accept the privacy policy",
    }),
  })
  .superRefine((data, ctx) => {
    if (data.is_hiring) {
      if (!data.size_of_organization?.trim()) {
        ctx.addIssue({
          path: ["size_of_organization"],
          code: z.ZodIssueCode.custom,
          message: "Size of your organization is required.",
        });
      }

      if (!data.number_of_vacancies?.trim()) {
        ctx.addIssue({
          path: ["number_of_vacancies"],
          code: z.ZodIssueCode.custom,
          message: "Current number of vacancies is required.",
        });
      }

      if (!data.want_to_reach_out?.trim()) {
        ctx.addIssue({
          path: ["want_to_reach_out"],
          code: z.ZodIssueCode.custom,
          message: "Please select who you want to reach out to.",
        });
      }
    }
  });

export type DownloadBrochureSchemaType = z.infer<typeof downloadBrochureSchema>;
